import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Collapsible from 'react-collapsible';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const FAQs = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    'section center-content',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'section-inner'
  );

  return (
        <section
        {...props}
        className={outerClasses}
        >
        <div className="container-sm">
          <div className={innerClasses}>
          
            <div>
              <h1 className="mt-0 mb-16 reveal-from-bottom section-header-title" data-reveal-delay="200">
                FAQs
              </h1>
            </div>
            {/**
             <Collapsible trigger="Will I make any money?">
                <p>
                    When you mint an EduVerse NFT, you’ll get access to a mystery NFT, which on reveal will transform into 1 of 5 rarities of NFT’s. In total we will have 5 phases of games to play, which can be accessed by the different rarities of NFT’s. Rarity 1 can access phase 1. Rarity 5 can access phase 1 2 3 4 5. Each phases’ prize gets exponentially more valuable. So imagine if you gained a rarity 5 NFT, that would be an instant flip in value already + you can still win prizes such as Tesla’s and more. And even if not, hey you just donated to charity. You’re a humanitarian. 
                </p>
            </Collapsible>
             */}
            <Collapsible trigger="Is EduVerse free to play?">
                <p>
                    Yes! There is no payment required to play our game! 
                </p>
            </Collapsible>
            <Collapsible trigger="Do I need a crypto wallet to join?">
                <p>
                    Crypto wallets are not required to join! You only need an email to create an account and start playing!
                </p>
            </Collapsible>
            <Collapsible trigger="How do I earn prizes?">
                <p>
                    You can earn prizes by collecting tokens that you acquire from playing our game. Once you have sufficient tokens, you can redeem prizes from our prize selection page!
                </p>
            </Collapsible>
          </div>
        </div>
      </section>
      
  );
}

FAQs.propTypes = propTypes;
FAQs.defaultProps = defaultProps;

export default FAQs;